export const FOOTER = {
  SOCIAL_TITLE: 'COMMON_FOOTER_SOCIAL_TITLE',
  CTA_ACCESS: 'COMMON_FOOTER_CTA_ACCESS',
  CTA_DISCOVER: 'COMMON_FOOTER_CTA_DISCOVER',
};
